import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Row,
  Col,
  Typography,
  Tag,
  Input,
  Select,
  Button,
  Checkbox,
  Spin,
} from "antd";
import "../../index.css";
import "../../App.css";
import NewEntryFormLeftColWrapper from "../wrappers/NewEntryFormLeftColWrapper";
import NewEntryFormRightColWrapper from "../wrappers/NewEntryFormRightColWrapper";
import { RootState, useAppDispatch } from "../../redux-toolkit/store/store";
import { useSelector } from "react-redux";
import {
  handleUpdateErrorsOfOrderCreamForm,
  handleUpdateMedicineHistory,
  handleGoBack,
  saveStep7Api,
  getOrderByTransactionIdApi,
  handleGoToNextStep,
} from "../../redux-toolkit/slices/orderCreamSlice";
import ErrorList from "../Items/ErrorsList";

const { Option } = Select;

const painDescriptionOptions: string[] = [
  "Prescription Medicine",
  "Over-the-Counter Products",
  "Vitamins/Supplements",
  "Physical Therapy/Exercise",
  "Hot/Cold Therapy",
  "Rest",
  "None of these",
  "Other",
];

const OcMedicineHistory = () => {
  const dispatch = useAppDispatch();
  const orderCreamForm = useSelector((state: RootState) => state.orderCream);
  const { isError, errors, medicineHistory, currentStep, transactionId, isLoading } = orderCreamForm;
  const [searchParams, setSearchParams] = useSearchParams();
  const [isLoadingOrder, setIsLoadingOrder] = useState(false);

  const [medicinedescriptions, setMedicineDescriptions] = useState<string[]>(
    []
  );
  const [medicineDetails, setMedicineDetails] = useState([
    {
      id: Date.now(),
      drugName: "",
      strength: "",
      form: "",
      usageFreq: "",
      duration: "",
    },
  ]);
  const [otcMedicineDetails, setOtcMedicineDetails] = useState([
    {
      id: Date.now(),
      drugName: "",
      strength: "",
      form: "",
      usageFreq: "",
      duration: "",
    },
  ]);
  const [otherDetails, setOtherDetails] = useState<string>("");

  const handleBack = () => {
    if (currentStep > 0) {
      const prevStep = currentStep - 1;
      const newParams = new URLSearchParams(searchParams);
      newParams.set("step", prevStep.toString());
      setSearchParams(newParams, { replace: true });
      // Don't call handleGoBack() - let the parent component sync from URL
    }
  };

  useEffect(() => {
    const {
      medicineDescriptions,
      medicineDetails,
      otcMedicineHistory,
      otherDetails,
    } = medicineHistory;
    setMedicineDescriptions(medicineDescriptions);
    setMedicineDetails(medicineDetails);
    setOtcMedicineDetails(otcMedicineHistory);
    setOtherDetails(otherDetails);
  }, []);
  const handlePainDescriptionChange = (description: string) => {
    dispatch(
      handleUpdateErrorsOfOrderCreamForm({ isError: false, errors: [] })
    );

    const updatedSelections = medicinedescriptions.includes(description)
      ? medicinedescriptions.filter((item) => item !== description)
      : [...medicinedescriptions, description];

    setMedicineDescriptions(updatedSelections);
  };

  const handleAddMedicineEntry = () => {
    setMedicineDetails([
      ...medicineDetails,
      {
        id: Date.now(),
        drugName: "",
        strength: "",
        form: "",
        usageFreq: "",
        duration: "",
      },
    ]);
  };

  const handleRemoveMedicineEntry = (id: number) => {
    setMedicineDetails(medicineDetails.filter((entry) => entry.id !== id));
  };

  const handleAddOtcMedicineEntry = () => {
    setOtcMedicineDetails([
      ...otcMedicineDetails,
      {
        id: Date.now(),
        drugName: "",
        strength: "",
        form: "",
        usageFreq: "",
        duration: "",
      },
    ]);
  };

  const handleRemoveOtcMedicineEntry = (id: number) => {
    setOtcMedicineDetails(
      otcMedicineDetails.filter((entry) => entry.id !== id)
    );
  };

  const handleDetailChange = (id: number, field: string, value: any) => {
    setMedicineDetails((prevDetails) =>
      prevDetails.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

  const handleOtcDetailChange = (id: number, field: string, value: any) => {
    setOtcMedicineDetails((prevDetails) =>
      prevDetails.map((entry) =>
        entry.id === id ? { ...entry, [field]: value } : entry
      )
    );
  };

  const isMedicineSelected = () => {
    return medicinedescriptions.includes("Prescription Medicine");
  };

  const isOtcMedicineSelected = () => {
    return medicinedescriptions.includes("Over-the-Counter Products");
  };
  const pleaseCompleteYouResponse = () => {
    const isError = true;
    const errors = ["Please complete your response"];
    return dispatch(handleUpdateErrorsOfOrderCreamForm({ isError, errors }));
  };
  const handleSubmit = async () => {
    if (medicinedescriptions.length > 0) {
      if (isMedicineSelected()) {
        for (const entry of medicineDetails) {
          if (
            !entry.drugName ||
            !entry.strength ||
            !entry.form ||
            !entry.usageFreq ||
            !entry.duration
          ) {
            return pleaseCompleteYouResponse();
          }
        }
      }

      if (isOtcMedicineSelected()) {
        for (const entry of otcMedicineDetails) {
          if (
            !entry.drugName ||
            !entry.strength ||
            !entry.form ||
            !entry.usageFreq ||
            !entry.duration
          ) {
            return pleaseCompleteYouResponse();
          }
        }
      }
      if (medicinedescriptions.includes("Other") && !otherDetails) {
        return pleaseCompleteYouResponse();
      }
      const medicineHistoryData = {
        medicineDescriptions: medicinedescriptions,
        medicineDetails: medicineDetails,
        otcMedicineHistory: otcMedicineDetails,
        otherDetails: otherDetails,
      };

      dispatch(
        handleUpdateMedicineHistory(medicineHistoryData)
      );

      if (!transactionId) {
        return dispatch(
          handleUpdateErrorsOfOrderCreamForm({
            isError: true,
            errors: ["Transaction ID is missing. Please refresh the page."],
          })
        );
      }

      try {
        // Sanitize medicineHistory to remove _id fields
        const sanitizedMedicineHistory = {
          medicineDescriptions: medicinedescriptions,
          medicineDetails: medicineDetails.map((entry: any) => {
            const { _id, ...rest } = entry;
            return rest;
          }),
          otcMedicineHistory: otcMedicineDetails.map((entry: any) => {
            const { _id, ...rest } = entry;
            return rest;
          }),
          otherDetails: otherDetails,
        };

        await dispatch(
          saveStep7Api({
            transactionId,
            medicineHistory: sanitizedMedicineHistory,
          })
        ).unwrap();

        // Update URL with new step
        const newParams = new URLSearchParams(searchParams);
        newParams.set("step", "8");
        setSearchParams(newParams, { replace: true });

        dispatch(handleGoToNextStep());
      } catch (error) {
        dispatch(
          handleUpdateErrorsOfOrderCreamForm({
            isError: true,
            errors: ["Failed to save step. Please try again."],
          })
        );
      }
      return;
    }
    const isError = true;
    const errors = ["Please Choose at least one for your medicine history"];
    return dispatch(handleUpdateErrorsOfOrderCreamForm({ isError, errors }));
  };

  return (
    <div className="medicine-history-entry">
      <div className="flex flex-col gap-5 w-full">
        {/* Medicine Management Question */}
        <div className="flex flex-col gap-2">
          <label className="h6 text-theme-text-secondary">
            <strong>How are you currently managing your pain or health condition? *</strong>
          </label>
          <p className="body1 text-theme-text-secondary mb-4">
            Select all that apply
          </p>
          <div className="flex flex-col gap-2">
            {painDescriptionOptions.map((option) => (
              <label key={option} className="flex items-center gap-3 cursor-pointer">
                <input 
                  type="checkbox" 
                  className="twinge-checkbox"
                  checked={medicinedescriptions.includes(option)}
                  onChange={() => handlePainDescriptionChange(option)}
                />
                <span className="body1">{option}</span>
              </label>
            ))}
          </div>
        </div>

        {/* Show medicine entry form when "Prescription Medicine" is selected */}
        {isMedicineSelected() &&
          medicineDetails.map((entry, index) => (
            <div key={entry.id} className="flex flex-col gap-2" style={{ marginTop: "20px" }}>
              <label className="h6 text-theme-text-secondary">
                <strong>Prescription Medicine Entry #{index + 1}</strong>
              </label>
              
              <div className="flex flex-col gap-3">
                <div className="flex gap-3">
                  <div className="flex-1">
                    <Input
                      placeholder="Drug Name"
                      value={entry.drugName}
                      onChange={(e) =>
                        handleDetailChange(entry.id, "drugName", e.target.value)
                      }
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                    />
                  </div>
                  <div className="flex-1">
                    <Input
                      placeholder="Strength (e.g., 500mg)"
                      value={entry.strength}
                      onChange={(e) =>
                        handleDetailChange(entry.id, "strength", e.target.value)
                      }
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                    />
                  </div>
                </div>
                
                <div className="flex gap-3">
                  <div className="flex-1">
                    <Select
                      placeholder="Form"
                      value={entry.form || undefined}
                      onChange={(value) =>
                        handleDetailChange(entry.id, "form", value)
                      }
                      className="w-full"
                    >
                      <Option value="tablet">Tablet</Option>
                      <Option value="capsule">Capsule</Option>
                      <Option value="liquid">Liquid</Option>
                      <Option value="ointment">Ointment</Option>
                      <Option value="cream">Cream</Option>
                      <Option value="gel">Gel</Option>
                      <Option value="patch">Patch</Option>
                      <Option value="spray">Spray</Option>
                    </Select>
                  </div>
                  <div className="flex-1">
                    <Select
                      placeholder="How often?"
                      value={entry.usageFreq || undefined}
                      onChange={(value) =>
                        handleDetailChange(entry.id, "usageFreq", value)
                      }
                      className="w-full"
                    >
                      <Option value="once">Once a day</Option>
                      <Option value="twice">Twice a day</Option>
                      <Option value="three">Three times a day</Option>
                      <Option value="as_needed">As needed</Option>
                    </Select>
                  </div>
                  <div className="flex-1">
                    <Select
                      placeholder="Duration"
                      value={entry.duration || undefined}
                      onChange={(value) =>
                        handleDetailChange(entry.id, "duration", value)
                      }
                      className="w-full"
                    >
                      <Option value="less_week">Less than a week</Option>
                      <Option value="less_month">Less than a month</Option>
                      <Option value="less_5_months">Less than 5 months</Option>
                      <Option value="less_year">Less than a year</Option>
                      <Option value="year_plus">1 year +</Option>
                    </Select>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <Button
                    shape="circle"
                    icon="+"
                    onClick={handleAddMedicineEntry}
                    style={{ marginRight: "10px" }}
                  />
                  {index > 0 && (
                    <Button
                      shape="circle"
                      icon="-"
                      onClick={() => handleRemoveMedicineEntry(entry.id)}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}

        {/* Show over-the-counter medicine entry form when "Over-the-Counter Products" is selected */}
        {isOtcMedicineSelected() &&
          otcMedicineDetails.map((entry, index) => (
            <div key={entry.id} className="flex flex-col gap-2" style={{ marginTop: "20px" }}>
              <label className="h6 text-theme-text-secondary">
                <strong>Over-the-Counter Medicine Entry #{index + 1}</strong>
              </label>
              
              <div className="flex flex-col gap-3">
                <div className="flex gap-3">
                  <div className="flex-1">
                    <Input
                      placeholder="Drug Name"
                      value={entry.drugName}
                      onChange={(e) =>
                        handleOtcDetailChange(
                          entry.id,
                          "drugName",
                          e.target.value
                        )
                      }
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                    />
                  </div>
                  <div className="flex-1">
                    <Input
                      placeholder="Strength (e.g., 500mg)"
                      value={entry.strength}
                      onChange={(e) =>
                        handleOtcDetailChange(
                          entry.id,
                          "strength",
                          e.target.value
                        )
                      }
                      className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
                    />
                  </div>
                </div>
                
                <div className="flex gap-3">
                  <div className="flex-1">
                    <Select
                      placeholder="Form"
                      value={entry.form || undefined}
                      onChange={(value) =>
                        handleOtcDetailChange(entry.id, "form", value)
                      }
                      className="w-full"
                    >
                      <Option value="tablet">Tablet</Option>
                      <Option value="capsule">Capsule</Option>
                      <Option value="liquid">Liquid</Option>
                      <Option value="ointment">Ointment</Option>
                      <Option value="cream">Cream</Option>
                      <Option value="gel">Gel</Option>
                      <Option value="patch">Patch</Option>
                      <Option value="spray">Spray</Option>
                    </Select>
                  </div>
                  <div className="flex-1">
                    <Select
                      placeholder="How often?"
                      value={entry.usageFreq || undefined}
                      onChange={(value) =>
                        handleOtcDetailChange(entry.id, "usageFreq", value)
                      }
                      className="w-full"
                    >
                      <Option value="once">Once a day</Option>
                      <Option value="twice">Twice a day</Option>
                      <Option value="three">Three times a day</Option>
                      <Option value="as_needed">As needed</Option>
                    </Select>
                  </div>
                  <div className="flex-1">
                    <Select
                      placeholder="Duration"
                      value={entry.duration || undefined}
                      onChange={(value) =>
                        handleOtcDetailChange(entry.id, "duration", value)
                      }
                      className="w-full"
                    >
                      <Option value="less_week">Less than a week</Option>
                      <Option value="less_month">Less than a month</Option>
                      <Option value="less_5_months">Less than 5 months</Option>
                      <Option value="less_year">Less than a year</Option>
                      <Option value="year_plus">1 year +</Option>
                    </Select>
                  </div>
                </div>

                <div className="flex items-center gap-2">
                  <Button
                    shape="circle"
                    icon="+"
                    onClick={handleAddOtcMedicineEntry}
                    style={{ marginRight: "10px" }}
                  />
                  {index > 0 && (
                    <Button
                      shape="circle"
                      icon="-"
                      onClick={() => handleRemoveOtcMedicineEntry(entry.id)}
                    />
                  )}
                </div>
              </div>
            </div>
          ))}

        {/* Other Details Section */}
        {medicinedescriptions.includes("Other") && (
          <div className="flex flex-col gap-2" style={{ marginTop: "20px" }}>
            <label className="h6 text-theme-text-secondary">
              <strong>Other Details</strong>
            </label>
            <Input
              placeholder="Please specify"
              value={otherDetails}
              onChange={(e) => {
                dispatch(
                  handleUpdateErrorsOfOrderCreamForm({
                    isError: false,
                    errors: [],
                  })
                );

                setOtherDetails(e.target.value);
              }}
              className="w-full px-4 py-3 border border-neutral-300 rounded-lg focus:border-primary-500 focus:ring-2 focus:ring-primary-200 focus:outline-none transition-all duration-200 bg-white custom-placeholder"
            />
          </div>
        )}

        {/* Error Display */}
        {isError === true && (
          <div className="mt-6">
            <ErrorList errors={errors} />
          </div>
        )}

        {/* Submit Button */}
        <div className="flex justify-center gap-4" style={{ marginTop: "40px" }}>
          <button
            onClick={handleBack}
            className="caption2 transition-colors duration-200"
            style={{ color: 'var(--primary-500)', textDecoration: 'none', background: 'none', border: 'none', cursor: 'pointer' }}
          >
            Previous
          </button>
          <button
            onClick={handleSubmit}
            className="btn btn-primary btn-lg"
            disabled={isLoading}
            style={{ position: 'relative', minWidth: '120px' }}
          >
            {isLoading ? (
              <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                <Spin size="small" />
                Saving...
              </span>
            ) : (
              'Next'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OcMedicineHistory;
